import { Alert, Box, BoxProps, Button, CssBaseline } from "@mui/material"
import { Loading } from "../../pages/Loading/Loading"
import { useAuthStore } from "../../zstore/AuthStore"
import { useDbStateStore } from "../../zstore/DbStateStore"
import { AuthComponent } from "../AuthComponent"
import { ErrorBoundary } from "../ErrorBoundary"
import { Header } from "../Header/Header"
import { useStyles } from "./styles"

export const Layout = ({ children }: BoxProps) => {
    const { classes } = useStyles()

    const loginError = useAuthStore((state) => state.loginError)
    const userLoading = useAuthStore((state) => state.userLoading)
    const logout = useAuthStore((state) => state.logout)
    const databaseError = useDbStateStore((state) => state.error)
    const user = useAuthStore((state) => state.user)
    const renderedError = databaseError || loginError

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Header />
            <AuthComponent />
            {renderedError && (
                <Box
                    maxWidth={600}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    flexDirection={"column"}
                    mx={"auto"}
                    height={"100vh"}
                >
                    <Alert severity="error">{renderedError}</Alert>
                    {databaseError == null && loginError != null && (
                        <Button variant={"outlined"} sx={{ mt: 2, mx: "auto" }} onClick={logout}>
                            Logout to Refresh
                        </Button>
                    )}
                </Box>
            )}
            {userLoading && <Loading label={"Fetching user..."} />}
            <ErrorBoundary>{renderedError == null && user != null && children}</ErrorBoundary>
        </div>
    )
}
